@if (isOpen()) {
  <div class="recap-overlay" (click)="close()">
    <div class="recap-modal" (click)="$event.stopPropagation()">
      <div class="recap-header">
        <div class="header-content">
          <span class="celebration-badge">
            <i class="pi pi-sparkles"></i>
            Fin de Saison
          </span>
          <h2 class="season-title">{{ season()?.title ?? 'Résumé de la Saison' }}</h2>
        </div>
        <button type="button" class="close-button" (click)="close()" aria-label="Fermer">
          <i class="pi pi-times"></i>
        </button>
      </div>

      <div class="recap-body">
        @if (isLoading()) {
          <div class="loading-state">
            <i class="pi pi-spin pi-spinner loading-spinner"></i>
            <p>Chargement des résultats...</p>
          </div>
        } @else if (hasError()) {
          <div class="empty-recap-state">
            <i class="pi pi-exclamation-triangle"></i>
            <p>Impossible de charger les résultats de cette saison.</p>
          </div>
        } @else if (recap()) {
          @if (podium().length === 0 && !userPerformance()?.participated) {
            <div class="empty-recap-state">
              <i class="pi pi-inbox"></i>
              <p>Aucune participation enregistrée pour cette saison.</p>
            </div>
          }

          <!-- Winner Section (Grand Vainqueur) -->
          @if (winner(); as firstPlace) {
            <div class="winner-card">
              <div class="winner-crown">
                <i class="pi pi-crown"></i>
                <span>1ère Place</span>
              </div>

              @if (firstPlace.outfitImageUrl) {
                <div class="winner-outfit-container">
                  <img
                    [src]="firstPlace.outfitImageUrl"
                    [alt]="'Tenue gagnante de ' + firstPlace.user.name"
                    class="winner-outfit-image"
                  />
                  <div class="winner-likes-pill">
                    <i class="pi pi-heart-fill"></i>
                    <span>{{ firstPlace.likesCount }} votes</span>
                  </div>
                </div>
              }

              <div class="winner-info">
                <div class="winner-user">
                  @if (firstPlace.user.picture) {
                    <img [src]="firstPlace.user.picture" [alt]="firstPlace.user.name" class="user-avatar" />
                  } @else {
                    <div class="user-avatar-placeholder">
                      {{ firstPlace.user.name.charAt(0).toUpperCase() }}
                    </div>
                  }
                  <span class="winner-name">{{ firstPlace.user.name }}</span>
                </div>

                @if (firstPlace.reward) {
                  <div class="reward-pill">
                    <i class="pi pi-gift"></i>
                    <span>{{ firstPlace.reward.title }}</span>
                  </div>
                }
              </div>
            </div>
          }

          <!-- Podium 2nd and 3rd place -->
          @if (runnerUps().length > 0) {
            <div class="podium-runner-ups">
              @for (entry of runnerUps(); track entry.rank) {
                <div class="runner-up-card" [class.silver]="entry.rank === 2" [class.bronze]="entry.rank === 3">
                  <div class="runner-rank-badge">
                    @if (entry.rank === 2) {
                      <span>🥈 2e</span>
                    } @else {
                      <span>🥉 3e</span>
                    }
                  </div>

                  @if (entry.outfitImageUrl) {
                    <img [src]="entry.outfitImageUrl" [alt]="entry.user.name" class="runner-outfit-thumb" />
                  }

                  <div class="runner-details">
                    <div class="runner-user-info">
                      @if (entry.user.picture) {
                        <img [src]="entry.user.picture" [alt]="entry.user.name" class="runner-avatar" />
                      }
                      <span class="runner-name">{{ entry.user.name }}</span>
                    </div>
                    <span class="runner-likes">
                      <i class="pi pi-heart-fill"></i> {{ entry.likesCount }}
                    </span>
                  </div>
                </div>
              }
            </div>
          }

          <!-- User Personal Performance Section -->
          @if (userPerformance(); as userPerf) {
            <div class="personal-performance-card">
              <div class="card-header">
                <i class="pi pi-chart-line"></i>
                <h3>Mon Bilan de Saison</h3>
              </div>

              @if (userPerf.participated) {
                <div class="performance-content">
                  @if (userPerf.outfitImageUrl) {
                    <img [src]="userPerf.outfitImageUrl" alt="Ma tenue" class="user-outfit-thumb" />
                  }
                  <div class="performance-stats">
                    <div class="rank-highlight">
                      <span class="rank-number">#{{ userPerf.rank }}</span>
                      <span class="rank-total">/ {{ userPerf.totalParticipants }}</span>
                      @if (userPerf.percentile !== null && userPerf.percentile !== undefined) {
                        <span class="percentile-tag">Top {{ userPerf.percentile }}%</span>
                      }
                    </div>

                    <div class="stats-row">
                      <span class="stat-item">
                        <i class="pi pi-heart-fill heart-icon"></i>
                        {{ userPerf.outfitLikesCount }} likes reçus
                      </span>
                      <span class="stat-item">
                        <i class="pi pi-check-circle"></i>
                        {{ userPerf.votesGivenCount }} votes donnés
                      </span>
                    </div>

                    @if (userPerf.curatorScoreGained !== 0) {
                      <div class="curator-gain-badge">
                        <i class="pi pi-star-fill"></i>
                        <span>
                          {{ userPerf.curatorScoreGained > 0 ? '+' : '' }}{{ userPerf.curatorScoreGained }} pts Curateur
                        </span>
                      </div>
                    }

                    @if (userPerf.reward) {
                      <div class="user-reward-won">
                        <i class="pi pi-trophy"></i>
                        <span>Récompense remportée : <strong>{{ userPerf.reward.title }}</strong></span>
                      </div>
                    }
                  </div>
                </div>
              } @else {
                <div class="non-participant-content">
                  <p class="curator-thank-you">
                    Tu n'as pas posté de tenue cette saison, mais ton vote a compté pour
                    <strong>{{ userPerf.votesGivenCount }} tenues</strong> !
                  </p>
                  @if (userPerf.curatorScoreGained !== 0) {
                    <div class="curator-gain-badge">
                      <i class="pi pi-star-fill"></i>
                      <span>
                        {{ userPerf.curatorScoreGained > 0 ? '+' : '' }}{{ userPerf.curatorScoreGained }} pts Curateur
                      </span>
                    </div>
                  }
                </div>
              }
            </div>
          }

          <!-- Global Stats -->
          @if (stats(); as globalStats) {
            <div class="global-stats-grid">
              <div class="stat-box">
                <i class="pi pi-images"></i>
                <div class="stat-data">
                  <span class="stat-number">{{ globalStats.totalParticipants }}</span>
                  <span class="stat-label">Tenues Partagées</span>
                </div>
              </div>

              <div class="stat-box">
                <i class="pi pi-thumbs-up"></i>
                <div class="stat-data">
                  <span class="stat-number">{{ globalStats.totalVotes }}</span>
                  <span class="stat-label">Votes Exprimés</span>
                </div>
              </div>
            </div>
          }

          <!-- Remaining Top 10 (4th to 10th) -->
          @if (remainingTop().length > 0) {
            <div class="top-list-section">
              <h4>Top 10 de la Saison</h4>
              <div class="top-list">
                @for (entry of remainingTop(); track entry.rank) {
                  <div class="top-list-row">
                    <span class="row-rank">#{{ entry.rank }}</span>
                    @if (entry.user.picture) {
                      <img [src]="entry.user.picture" [alt]="entry.user.name" class="row-avatar" />
                    } @else {
                      <div class="row-avatar-placeholder">
                        {{ entry.user.name.charAt(0).toUpperCase() }}
                      </div>
                    }
                    <span class="row-name">{{ entry.user.name }}</span>
                    <span class="row-likes"><i class="pi pi-heart-fill"></i> {{ entry.likesCount }}</span>
                  </div>
                }
              </div>
            </div>
          }
        }
      </div>

      <div class="recap-footer">
        <button
          type="button"
          class="share-button"
          (click)="shareResult()"
          aria-label="Partager mon résultat"
        >
          <i class="pi pi-share-alt"></i>
          <span>Partager</span>
        </button>

        <button
          type="button"
          class="cta-button"
          (click)="discoverNewSeason()"
          aria-label="Découvrir la nouvelle saison"
        >
          <i class="pi pi-compass"></i>
          <span>Découvrir la saison active</span>
        </button>
      </div>
    </div>
  </div>
}
